exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:Inconsolata;font-style:normal;font-weight:400;src:url(" + require("../fonts/inconsolata/Inconsolata-Regular.ttf") + ") format('truetype')}@font-face{font-family:Inconsolata;font-style:normal;font-weight:700;src:url(" + require("../fonts/inconsolata/Inconsolata-Bold.ttf") + ") format('truetype')}@font-face{font-family:Open Sans;font-style:normal;font-weight:400;src:url(" + require("../fonts/opensans/OpenSans-Regular.ttf") + ") format('truetype')}@font-face{font-family:Open Sans;font-style:normal;font-weight:700;src:url(" + require("../fonts/opensans/OpenSans-Bold.ttf") + ") format('truetype')}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/sass/_fonts.css
// module id = 124
// module chunks = 0